import { TOUR_IDS } from "@demandproai/shared";
import { TourGateProvider } from "../../contexts/TourGateContext";
import RenderIf from "../render-if/Renderif";
import useEditCaseTour from "../../hooks/useEditCaseTour";
import useTourRefresher from "../../hooks/useTourRefresher";
import TourRefresherPrompt from "./TourRefresherPrompt";

const EditCaseTourRunner = () => {
   const { Tour, gate } = useEditCaseTour();
   const { isOffering, acceptRefresher, declineRefresher } = useTourRefresher({
      tourId: TOUR_IDS.EDIT_CASE,
   });

   return (
      <TourGateProvider value={gate}>
         {Tour}

         <RenderIf shouldRender={isOffering}>
            <TourRefresherPrompt onAccept={acceptRefresher} onDecline={declineRefresher} />
         </RenderIf>
      </TourGateProvider>
   );
};

export default EditCaseTourRunner;
